import React, { CSSProperties } from "react";

// Common
import { Table } from "react-lib/frameworks/Table";

// Type
type TableIssueHistoryProps = {
  data: any[]; // *
  style?: CSSProperties;
};

const TableIssueHistory = (props: TableIssueHistoryProps) => {
  return (
    <Table
      className="--rt-tbody-overflow-y-hidden"
      headers="Date - Time, Detail, Updated by"
      keys="created_on, details, user"
      minRows={5}
      showPagination={false}
      sortable={false}
      style={props.style}
      data={props.data}
      widths="^100, ^300, ^150"
    />
  );
};

export default React.memo(TableIssueHistory);
